import React, { useState } from "react";
import styled, { keyframes, createGlobalStyle } from "styled-components";
import { motion, AnimatePresence } from "framer-motion";
import Hero from "../components/Hero";
import { SliderDataEight } from "../data/SliderData";
import MenuImage from "../images/lunchmenu.png";
import MenuTwoImage from "../images/breakfastOne.png";
import MenuThreeImage from "../images/breakfastThree.png";
import MenuFourImage from "../images/breakfastFour.png";
import MenuFiveImage from "../images/breakfastFive.png";
import MenuLunchTwoImage from "../images/lunchmenutwo.png";


/* ─── Fonts ─────────────────────────────────────────────────── */
const FontLoader = createGlobalStyle`
  @import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,300;0,400;0,600;1,300;1,400&family=Bebas+Neue&family=Jost:wght@300;400;500;600&display=swap');
`;

/* ─── Design Tokens ─────────────────────────────────────────── */
const gold   = "#c9a96e";
const cream  = "#f5f0e8";
const ink    = "#0e0c0a";
const mist   = "#1c1915";
const slate  = "#2a2520";
const steel  = "#6eb8c9";
const body   = "rgba(245,240,232,0.72)";
const display = `'Cormorant Garamond', Georgia, serif`;
const sans    = `'Jost', sans-serif`;
const slab    = `'Bebas Neue', sans-serif`;

/* ─── Keyframes ─────────────────────────────────────────────── */
const rotateSlow = keyframes`
  from { transform: rotate(0deg); }
  to   { transform: rotate(360deg); }
`;
const marquee = keyframes`
  from { transform: translateX(0); }
  to   { transform: translateX(-50%); }
`;

/* ─── Animation Variants ────────────────────────────────────── */
const stagger = {
  hidden: {},
  show: { transition: { staggerChildren: 0.12 } },
};
const fadeUp = {
  hidden: { opacity: 0, y: 36 },
  show: { opacity: 1, y: 0, transition: { duration: 0.72, ease: [0.22, 1, 0.36, 1] } },
};

/* ─── Component ─────────────────────────────────────────────── */
const Breakfastscreen = () => {
  const [selectedImage, setSelectedImage] = useState(null);

  React.useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === "Escape" && selectedImage) setSelectedImage(null);
    };
    window.addEventListener("keydown", handleEscape);
    return () => window.removeEventListener("keydown", handleEscape);
  }, [selectedImage]);

  const menuItems = [
    {
      img: MenuThreeImage,
      title: "Specialty Breakfast",
      subtitle: "Signature Dishes",
      description: "Our unique takes on breakfast classics. These signature dishes showcase the best of what Little Heaven has to offer.",
      time: "8:00 AM - 9:00 AM",
      tag: "Guest Favorite",
    },
    {
      img: MenuFiveImage,
      title: "Breakfast Selection",
      subtitle: "Mountain Morning",
      description: "Authentic mountain breakfast served with warmth and hospitality. You'll leave our table satisfied and eager to return.",
      time: "8:00 AM - 9:00 AM",
      tag: "Seasonal",
    },
    {
      img: MenuTwoImage,
      title: "Lunch Classics",
      subtitle: "Lunch Favorites",
      description: "Traditional lunch fare prepared with love and attention to detail. ",
      time: "8:00 AM - 9:00 AM",
      tag: "House Classic",
    },
    {
      img: MenuFourImage,
      title: "Breakfast Delights",
      subtitle: "Start Your Day Right",
      description: "Perfectly prepared morning meals that energize your mountain adventures. Each plate is a celebration of fresh ingredients and culinary craft.",
      time: "8:00 AM - 9:00 AM",
      tag: "Chef's Pick",
    },
    {
      img: MenuImage,
      title: "Lunch Menu",
      subtitle: "Afternoon Delights",
      description: "Fresh, locally-sourced ingredients crafted into delicious lunch selections. From hearty sandwiches to fresh salads, every dish tells a story of mountain-fresh flavor.",
      time: "10:30 AM - 2:30 PM",
      tag: "Public Cafe",
    },
    {
      img: "https://i.postimg.cc/GtGXgfSR/lunchmenutwo.png",
      title: "Complete Lunch Menu",
      subtitle: "Afternoon Selections",
      description: "Browse our full afternoon menu — fresh, locally-sourced ingredients crafted into satisfying lunch selections available to guests and the public alike.",
      time: "10:30 AM - 2:30 PM",
      tag: "Full Menu",
    },
  ];

  // Breakfast + Dinner only in the full menus grid
  const completeMenus = [
    {
      img: "https://i.postimg.cc/L8FjNZvv/DINNER-MENU-of-LH-1-(1).png",
      title: "Complete Breakfast Menu",
      subtitle: "Morning Selections",
      label: "AM",
    },
    {
      img: "https://i.postimg.cc/8PKqvNbb/DINNER-MENU-of-LH-2.png",
      title: "Complete Dinner Menu",
      subtitle: "Evening Favorites",
      label: "PM",
    },
  ];

  return (
    <>
      <FontLoader />
      <PageWrapper>
        <Hero slides={SliderDataEight} />

        {/* ── Masthead ─────────────────────────────────────── */}
        {/* <Masthead>
          <MastheadNoise />
          <MastheadGlow />
          <MastheadInner
            as={motion.div}
            variants={stagger}
            initial="hidden"
            animate="show"
          >
            <EyebrowRow as={motion.div} variants={fadeUp}>
              <EyebrowLine />
              <Eyebrow>Little Heaven Cafe</Eyebrow>
              <EyebrowLine $flipped />
            </EyebrowRow>
            <MastheadTitle as={motion.div} variants={fadeUp}>
              Breakfast&nbsp;&amp;<br />Afternoon&nbsp;Treats
            </MastheadTitle>
            <MastheadSub as={motion.div} variants={fadeUp}>
              Dining is an essential part of the Little Heaven experience
            </MastheadSub>
          </MastheadInner>

          <RotatingBadge aria-hidden="true">
            <svg viewBox="0 0 100 100" width="120" height="120">
              <defs>
                <path id="circ" d="M 50,50 m -37,0 a 37,37 0 1,1 74,0 a 37,37 0 1,1 -74,0" />
              </defs>
              <text fontSize="11" fill={gold} fontFamily="Jost, sans-serif" fontWeight="500" letterSpacing="3.2">
                <textPath href="#circ">LITTLE HEAVEN · HAMPTONVILLE NC · EST. 2020 · </textPath>
              </text>
            </svg>
            <RotatingCenter>✦</RotatingCenter>
          </RotatingBadge>
        </Masthead> */}

        {/* ── Included Banner ──────────────────────────────── */}
        <IncludedSection>
          <IncludedGrid>
            <IncludedCard>
              <IncludedIconBg>🏡</IncludedIconBg>
              <IncludedLabel $accent={gold}>*Please Note*</IncludedLabel>
              <IncludedHeading>
                The Cafe is separate from our Bed & Breakfast and is open on select days.
              </IncludedHeading>
              <IncludedRule $accent={gold} />
              <IncludedBody>
                (Overnight guests--don't worry, your daily breakfast is always included with your stay!)
              </IncludedBody>
              <IncludedPill $accent={gold}>✓ Guest breakfast always included</IncludedPill>
            </IncludedCard>

            <IncludedDividerCol>
              <IncludedDividerLine />
              <IncludedDividerStar>✦</IncludedDividerStar>
              <IncludedDividerLine />
            </IncludedDividerCol>

            <IncludedCard>
              <IncludedIconBg>☕</IncludedIconBg>
              <IncludedLabel $accent={steel}>Little Heaven Cafe</IncludedLabel>
              <IncludedHeading>
                Open to<br />the Public —<br />Always Welcome
              </IncludedHeading>
              <IncludedRule $accent={steel} />
              <IncludedBody>
                Not staying with us? You're still family. The cafe is open to the entire
                community with fresh breakfast and lunch. Pull up a chair on the porch —
                no reservation needed.
              </IncludedBody>
              <IncludedPill $accent={steel}>✓ No reservation needed</IncludedPill>
            </IncludedCard>
          </IncludedGrid>
        </IncludedSection>

        {/* ── Cafe Hours ───────────────────────────────────── */}
        <HoursSection>
          <HoursInner>
            <HoursEyebrow>Cafe Hours</HoursEyebrow>
            <HoursHeading>
              Little Heaven Café is open to the public<br />
              <em>Thursday, Friday &amp; Saturday</em>
            </HoursHeading>
            <HoursRule />
            <HoursTime>8:00 AM – 2:30 PM</HoursTime>
            <HoursNote>
              Walk-ins are always welcome — no reservation needed.
            </HoursNote>
          </HoursInner>
        </HoursSection>

        {/* ── Story Section ────────────────────────────────── */}
        {/* <StorySection>
          <StoryGlow />
          <StoryContainer
            as={motion.div}
            variants={stagger}
            initial="hidden"
            whileInView="show"
            viewport={{ once: true, margin: "-80px" }}
          >
            <StorySide as={motion.div} variants={stagger}>
              <SectionEyebrow as={motion.div} variants={fadeUp}>Our Morning</SectionEyebrow>
              <StoryTitle as={motion.div} variants={fadeUp}>
                The Mountain<br /><em>Morning</em><br />Experience
              </StoryTitle>
              <StoryText as={motion.div} variants={fadeUp}>
                The morning in the mountains arrives full of fresh air, birdsong, and coffee.
                That first scent drifting from the kitchen is your signal — breakfast is near.
              </StoryText>
              <StoryText as={motion.div} variants={fadeUp}>
                Coffee flows from <Hl>7:00 AM</Hl>. A full, made-from-scratch breakfast follows
                with seating from <Hl>8:00 to 9:00 AM</Hl> — indoors by the fire or outside
                under the open sky.
              </StoryText>
              <StoryQuote as={motion.div} variants={fadeUp}>
                "You will leave our table satisfied<br />and already planning your return."
              </StoryQuote>
            </StorySide>

            <StoryCards as={motion.div} variants={stagger}>
              {[
                { icon: "☕", label: "Coffee Ready",    time: "7:00 AM" },
                { icon: "🍳", label: "Breakfast Served", time: "8:00 – 9:00 AM" },
                { icon: "🌄", label: "In or Outdoors",  time: "Your Choice" },
              ].map((c) => (
                <TimeCard
                  key={c.label}
                  as={motion.div}
                  variants={fadeUp}
                  whileHover={{ y: -6, transition: { duration: 0.28 } }}
                >
                  <TimeIcon>{c.icon}</TimeIcon>
                  <TimeLabel>{c.label}</TimeLabel>
                  <TimeVal>{c.time}</TimeVal>
                </TimeCard>
              ))}
            </StoryCards>
          </StoryContainer>
        </StorySection> */}

        {/* ── Cafe Public ──────────────────────────────────── */}
        <CafeSection>
          <MastheadNoise />
          <CafeGlow />
          <CafeContent
            as={motion.div}
            variants={stagger}
            initial="hidden"
            whileInView="show"
            viewport={{ once: true }}
          >
            <SectionEyebrow as={motion.div} variants={fadeUp} $light>Open to Everyone</SectionEyebrow>
            <CafeTitle as={motion.div} variants={fadeUp}>
              Little Heaven<br /><em>Cafe</em>
            </CafeTitle>
            <CafeTagline as={motion.div} variants={fadeUp}>
              Where Time Slows Down
            </CafeTagline>
            <CafeDesc as={motion.div} variants={fadeUp}>
              Follow the winding road to a place built for lingering. Located on the grounds
              of our Bed &amp; Breakfast, Little Heaven Cafe welcomes everyone with a menu
              built on freshness, flavor, and genuine mountain hospitality.
            </CafeDesc>
            <CafeFeatures as={motion.div} variants={stagger}>
              {[
                { icon: "☕", text: "Morning caffeine rituals" },
                { icon: "🥗", text: "Fresh lunch selections" },
                { icon: "🌿", text: "Porch dining with a view" },
              ].map((f) => (
                <CafeFeature key={f.text} as={motion.div} variants={fadeUp}>
                  <span>{f.icon}</span>
                  <span>{f.text}</span>
                </CafeFeature>
              ))}
            </CafeFeatures>
            <CafeWelcome as={motion.div} variants={fadeUp}>
              We've got a seat waiting for you
            </CafeWelcome>
          </CafeContent>
        </CafeSection>

        {/* ── Full Menus (Breakfast + Dinner, centered 2-col) ── */}
        {/* <FullMenuSection>
          <SectionHeader
            as={motion.div}
            variants={stagger}
            initial="hidden"
            whileInView="show"
            viewport={{ once: true }}
          >
            <SectionEyebrow as={motion.div} variants={fadeUp}>Browse Our Menus</SectionEyebrow>
            <FullMenuTitle as={motion.div} variants={fadeUp}>Explore Our Full Menus</FullMenuTitle>
            <FullMenuSub as={motion.div} variants={fadeUp}>
              Every dish tells a story of tradition and mountain-fresh excellence
            </FullMenuSub>
          </SectionHeader>

          <FullMenuGrid
            as={motion.div}
            variants={stagger}
            initial="hidden"
            whileInView="show"
            viewport={{ once: true }}
          >
            {completeMenus.map((menu, i) => (
              <FullMenuCard
                key={i}
                as={motion.div}
                variants={fadeUp}
                whileHover={{ y: -10, transition: { duration: 0.35, ease: [0.22, 1, 0.36, 1] } }}
                onClick={() => setSelectedImage(menu)}
              >
                <FMLabel>{menu.label}</FMLabel>
                <FMImgWrap>
                  <FMImg src={menu.img} alt={menu.title} />
                  <FMOverlay>
                    <FMZoom>View Menu ↗</FMZoom>
                  </FMOverlay>
                </FMImgWrap>
                <FMBody>
                  <FMSub>{menu.subtitle}</FMSub>
                  <FMTitle>{menu.title}</FMTitle>
                </FMBody>
              </FullMenuCard>
            ))}
          </FullMenuGrid>
        </FullMenuSection> */}

        {/* ── Gallery ──────────────────────────────────────── */}
        <GallerySection>
          <GalleryHeaderRow
            as={motion.div}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7 }}
          >
            <SectionEyebrow>What We Serve</SectionEyebrow>
            <GalleryTitle>Morning &amp; Afternoon</GalleryTitle>
          </GalleryHeaderRow>

          <StackedList>
            {menuItems.map((item, i) => (
              <StackedItem
                key={i}
                as={motion.div}
                initial={{ opacity: 0, y: 60 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-80px" }}
                transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
              >
                <StackedTextRow>
                  <StackedLeft>
                    <StackedNum>0{i + 1}</StackedNum>
                    <div>
                      <StackedSub>{item.subtitle}</StackedSub>
                      <StackedTitle>{item.title}</StackedTitle>
                    </div>
                  </StackedLeft>
                  <StackedRight>
                    <StackedDesc>{item.description}</StackedDesc>
                    <StackedTag>{item.tag}</StackedTag>
                  </StackedRight>
                </StackedTextRow>
                <StackedDivider />
                <StackedImgWrap onClick={() => setSelectedImage(item)}>
                  <StackedImg src={item.img} alt={item.title} />
                  <StackedOverlay>
                    <StackedOverlayBtn>Expand ↗</StackedOverlayBtn>
                  </StackedOverlay>
                </StackedImgWrap>
              </StackedItem>
            ))}
          </StackedList>

        </GallerySection>

        {/* ── Marquee Strip ────────────────────────────────── */}
        <MarqueeStrip>
          <MarqueeInner>
            {Array(8).fill("LITTLE HEAVEN · HAMPTONVILLE, NC ·").map((t, i) => (
              <MarqueeText key={i}>{t}</MarqueeText>
            ))}
          </MarqueeInner>
        </MarqueeStrip>

        {/* ── Lightbox ─────────────────────────────────────── */}
        {selectedImage && (
          <Lightbox
            as={motion.div}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={() => setSelectedImage(null)}
          >
            <LBContent
              as={motion.div}
              initial={{ scale: 0.88, opacity: 0, y: 40 }}
              animate={{ scale: 1, opacity: 1, y: 0 }}
              transition={{ type: "spring", damping: 28, stiffness: 260 }}
              onClick={(e) => e.stopPropagation()}
            >
              <LBClose onClick={() => setSelectedImage(null)}>✕</LBClose>
              <LBHint>Press ESC to close</LBHint>
              <LBImg src={selectedImage.img} alt={selectedImage.title} />
              <LBMeta>
                <LBSub>{selectedImage.subtitle}</LBSub>
                <LBTitle>{selectedImage.title}</LBTitle>
                {selectedImage.description && (
                  <LBDesc>{selectedImage.description}</LBDesc>
                )}
              </LBMeta>
            </LBContent>
          </Lightbox>
        )}

      </PageWrapper>
    </>
  );
};

export default Breakfastscreen;

/* ═══════════════════════════════════════════════════════════════
   STYLED COMPONENTS
═══════════════════════════════════════════════════════════════ */

const PageWrapper = styled.div`
  width: 100%;
  overflow-x: hidden;
  background: #fff;
  color: ${cream};
  font-family: ${sans};
`;

/* ── Masthead ────────────────────────────────────────────────── */
const Masthead = styled.section`
  position: relative;
  min-height: 52vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(160deg, #141210 0%, #1e1a14 60%, #0e0c0a 100%);
  overflow: hidden;
  padding: 90px 24px 80px;
  &::before {
    content: '';
    position: absolute;
    inset: 0;
    background:
      radial-gradient(ellipse 70% 60% at 20% 40%, rgba(201,169,110,0.07) 0%, transparent 60%),
      radial-gradient(ellipse 50% 40% at 80% 60%, rgba(110,184,201,0.05) 0%, transparent 60%);
  }
`;

const MastheadNoise = styled.div`
  position: absolute;
  inset: 0;
  opacity: 0.025;
  background-image: url("data:image/svg+xml,%3Csvg viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='4'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)'/%3E%3C/svg%3E");
  background-size: 200px;
  pointer-events: none;
`;

const MastheadGlow = styled.div`
  position: absolute;
  inset: 0;
  background:
    radial-gradient(ellipse 70% 60% at 20% 40%, rgba(201,169,110,0.07) 0%, transparent 60%),
    radial-gradient(ellipse 50% 40% at 80% 60%, rgba(110,184,201,0.05) 0%, transparent 60%);
  pointer-events: none;
`;

const MastheadInner = styled.div`
  position: relative;
  z-index: 2;
  text-align: center;
  max-width: 900px;
`;

const EyebrowRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
  margin-bottom: 28px;
`;

const EyebrowLine = styled.div`
  flex: 1;
  max-width: 80px;
  height: 1px;
  background: ${(p) => p.$flipped
    ? `linear-gradient(90deg, ${gold}, transparent)`
    : `linear-gradient(90deg, transparent, ${gold})`};
`;

const Eyebrow = styled.span`
  font-family: ${sans};
  font-size: 11px;
  font-weight: 500;
  letter-spacing: 4px;
  text-transform: uppercase;
  color: ${gold};
`;

const MastheadTitle = styled.h1`
  font-family: ${display};
  font-size: clamp(3.6rem, 8vw, 7.5rem);
  font-weight: 300;
  line-height: 1.0;
  color: ${cream};
  margin: 0 0 28px;
  letter-spacing: -1px;
`;

const MastheadSub = styled.p`
  font-family: ${sans};
  font-size: clamp(0.9rem, 1.8vw, 1.1rem);
  font-weight: 300;
  letter-spacing: 1.5px;
  color: rgba(245,240,232,0.65);
  margin: 0;
`;

const RotatingBadge = styled.div`
  position: absolute;
  bottom: 36px;
  right: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  animation: ${rotateSlow} 18s linear infinite;
  @media (max-width: 768px) { display: none; }
`;

const RotatingCenter = styled.span`
  position: absolute;
  font-size: 1.4rem;
  color: ${gold};
  animation: ${rotateSlow} 18s linear infinite reverse;
`;

/* ── Included Banner ─────────────────────────────────────────── */
const IncludedSection = styled.section`
  background: linear-gradient(135deg, #13110e 0%, #1a1610 100%);
  padding: 70px 40px;
  border-top: 1px solid rgba(201,169,110,0.15);
  border-bottom: 1px solid rgba(201,169,110,0.15);
  @media (max-width: 768px) { padding: 50px 24px; }
`;

/*
  1fr auto 1fr => note card | divider | cafe card
  The divider column sizes to its own content instead of
  eating a full half of the grid.
*/
const IncludedGrid = styled.div`
  max-width: 1160px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  gap: 0 48px;
  align-items: center;
  @media (max-width: 860px) {
    grid-template-columns: 1fr;
    gap: 40px 0;
  }
`;

const IncludedCard = styled.div`
  padding: 0 16px;
`;

const IncludedIconBg = styled.div`
  font-size: 2.4rem;
  line-height: 1;
  margin-bottom: 18px;
`;

const IncludedLabel = styled.div`
  font-family: ${sans};
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 3.5px;
  text-transform: uppercase;
  color: ${(p) => p.$accent};
  margin-bottom: 14px;
`;

const IncludedHeading = styled.h3`
  font-family: ${display};
  font-size: clamp(1.8rem, 3vw, 2.5rem);
  font-weight: 400;
  line-height: 1.15;
  color: ${cream};
  margin: 0 0 20px;
  letter-spacing: -0.3px;
`;

const IncludedRule = styled.div`
  width: 48px;
  height: 2px;
  background: ${(p) => p.$accent};
  margin-bottom: 20px;
  border-radius: 2px;
`;

const IncludedBody = styled.p`
  font-family: ${sans};
  font-size: 0.95rem;
  font-weight: 300;
  line-height: 1.9;
  color: ${body};
  margin: 0 0 24px;
  strong { color: ${cream}; font-weight: 500; }
`;

const IncludedPill = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 20px;
  border: 1px solid ${(p) => p.$accent}55;
  border-radius: 100px;
  font-family: ${sans};
  font-size: 11px;
  font-weight: 500;
  letter-spacing: 1.5px;
  text-transform: uppercase;
  color: ${(p) => p.$accent};
  background: ${(p) => p.$accent}0d;
`;

const IncludedDividerCol = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  align-self: stretch;
  @media (max-width: 860px) {
    flex-direction: row;
    width: 100%;
    align-self: auto;
  }
`;

const IncludedDividerLine = styled.div`
  flex: 1;
  width: 1px;
  min-height: 60px;
  background: rgba(201,169,110,0.2);
  @media (max-width: 860px) {
    width: auto;
    height: 1px;
    min-height: unset;
  }
`;

const IncludedDividerStar = styled.div`
  font-size: 1rem;
  color: ${gold};
  opacity: 0.45;
  flex-shrink: 0;
`;

/* ── Cafe Hours ──────────────────────────────────────────────── */
const HoursSection = styled.section`
  background: #f9f5ee;
  padding: 72px 24px;
  text-align: center;
  border-bottom: 1px solid rgba(201,169,110,0.2);
`;

const HoursInner = styled.div`
  max-width: 700px;
  margin: 0 auto;
`;

const HoursEyebrow = styled.p`
  font-family: ${sans};
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 4px;
  text-transform: uppercase;
  color: ${gold};
  margin: 0 0 16px;
`;

const HoursHeading = styled.h2`
  font-family: ${display};
  font-size: clamp(1.8rem, 4vw, 3rem);
  font-weight: 300;
  line-height: 1.25;
  color: #0e0c0a;
  margin: 0 0 20px;
  em { font-style: italic; color: ${gold}; }
`;

const HoursRule = styled.div`
  width: 56px;
  height: 2px;
  background: ${gold};
  opacity: 0.4;
  margin: 0 auto 20px;
  border-radius: 2px;
`;

const HoursTime = styled.p`
  font-family: ${slab};
  font-size: clamp(2rem, 5vw, 3.5rem);
  letter-spacing: 3px;
  color: ${gold};
  margin: 0 0 16px;
  line-height: 1;
`;

const HoursNote = styled.p`
  font-family: ${sans};
  font-size: 0.95rem;
  font-weight: 300;
  color: rgba(40,32,24,0.6);
  margin: 0;
  line-height: 1.7;
`;

/* ── Shared ──────────────────────────────────────────────────── */
const SectionHeader = styled.div`
  text-align: center;
  margin-bottom: 60px;
`;

const SectionEyebrow = styled.div`
  font-family: ${sans};
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 4px;
  text-transform: uppercase;
  color: ${(p) => p.$light ? "rgba(201,169,110,0.75)" : gold};
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 14px;
  &::before, &::after {
    content: '';
    display: inline-block;
    width: 26px;
    height: 1px;
    background: ${gold};
    opacity: 0.45;
  }
`;

/* ── Story Section ───────────────────────────────────────────── */
const StorySection = styled.section`
  position: relative;
  padding: 120px 40px;
  background: #0e0c0a;
  overflow: hidden;
  @media (max-width: 768px) { padding: 80px 24px; }
`;

const StoryGlow = styled.div`
  position: absolute;
  inset: 0;
  background: radial-gradient(ellipse 60% 50% at 100% 50%, rgba(201,169,110,0.05) 0%, transparent 60%);
  pointer-events: none;
`;

const StoryContainer = styled.div`
  max-width: 1280px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1.1fr 0.9fr;
  gap: 100px;
  align-items: start;
  @media (max-width: 1000px) {
    grid-template-columns: 1fr;
    gap: 60px;
  }
`;

const StorySide = styled.div``;

const StoryTitle = styled.h2`
  font-family: ${display};
  font-size: clamp(3rem, 5.5vw, 5.2rem);
  font-weight: 300;
  line-height: 1.05;
  color: ${cream};
  margin: 0 0 36px;
  letter-spacing: -0.5px;
  em { font-style: italic; color: ${gold}; }
`;

const StoryText = styled.p`
  font-family: ${sans};
  font-size: 1rem;
  font-weight: 300;
  line-height: 1.9;
  color: ${body};
  margin: 0 0 20px;
`;

const Hl = styled.span`
  color: ${gold};
  font-weight: 500;
`;

const StoryQuote = styled.blockquote`
  font-family: ${display};
  font-size: clamp(1.1rem, 1.8vw, 1.35rem);
  font-style: italic;
  font-weight: 300;
  line-height: 1.75;
  color: ${cream};
  margin: 40px 0 0;
  padding: 28px 32px;
  border-left: 2px solid ${gold};
  background: rgba(201,169,110,0.04);
  border-radius: 0 12px 12px 0;
`;

const StoryCards = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const TimeCard = styled.div`
  background: linear-gradient(135deg, rgba(255,255,255,0.04), rgba(255,255,255,0.01));
  border: 1px solid rgba(201,169,110,0.14);
  border-radius: 16px;
  padding: 26px 30px;
  display: flex;
  align-items: center;
  gap: 18px;
  backdrop-filter: blur(8px);
  transition: border-color 0.3s, background 0.3s;
  cursor: default;
  &:hover {
    border-color: rgba(201,169,110,0.38);
    background: linear-gradient(135deg, rgba(201,169,110,0.06), rgba(201,169,110,0.02));
  }
`;

const TimeIcon = styled.div`
  font-size: 2rem;
  flex-shrink: 0;
`;

const TimeLabel = styled.div`
  flex: 1;
  font-family: ${sans};
  font-size: 0.92rem;
  font-weight: 400;
  color: ${cream};
`;

const TimeVal = styled.div`
  font-family: ${slab};
  font-size: 1.25rem;
  letter-spacing: 1px;
  color: ${gold};
`;

/* ── Cafe Section ────────────────────────────────────────────── */
const CafeSection = styled.section`
  position: relative;
  min-height: 70vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 120px 24px;
  background: linear-gradient(160deg, #141210, #0e0c0a);
  overflow: hidden;
`;

const CafeGlow = styled.div`
  position: absolute;
  inset: 0;
  background: radial-gradient(ellipse 80% 60% at 50% 50%, rgba(201,169,110,0.07) 0%, transparent 65%);
  pointer-events: none;
`;

const CafeContent = styled.div`
  position: relative;
  z-index: 2;
  text-align: center;
  max-width: 860px;
`;

const CafeTitle = styled.h2`
  font-family: ${display};
  font-size: clamp(4rem, 8vw, 7.5rem);
  font-weight: 300;
  line-height: 1.0;
  color: ${cream};
  margin: 0 0 18px;
  letter-spacing: -1px;
  em { font-style: italic; color: ${gold}; }
`;

const CafeTagline = styled.div`
  font-family: ${display};
  font-size: clamp(1.1rem, 2.2vw, 1.6rem);
  font-style: italic;
  color: ${gold};
  margin-bottom: 32px;
`;

const CafeDesc = styled.p`
  font-family: ${sans};
  font-size: clamp(0.9rem, 1.5vw, 1.05rem);
  font-weight: 300;
  line-height: 1.9;
  color: ${body};
  max-width: 700px;
  margin: 0 auto 52px;
`;

const CafeFeatures = styled.div`
  display: flex;
  justify-content: center;
  gap: 48px;
  margin-bottom: 48px;
  flex-wrap: wrap;
  @media (max-width: 600px) { gap: 24px; }
`;

const CafeFeature = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  font-family: ${sans};
  font-size: 0.9rem;
  font-weight: 400;
  color: ${body};
  span:first-child { font-size: 1.7rem; }
`;

const CafeWelcome = styled.div`
  font-family: ${display};
  font-size: clamp(1.2rem, 2.5vw, 1.8rem);
  font-style: italic;
  color: rgba(245,240,232,0.55);
`;

/* ── Full Menu Section ───────────────────────────────────────── */
const FullMenuSection = styled.section`
  padding: 120px 40px 100px;
  background: ${mist};
  @media (max-width: 768px) { padding: 80px 24px 70px; }
`;

const FullMenuTitle = styled.h2`
  font-family: ${display};
  font-size: clamp(2.8rem, 5vw, 5rem);
  font-weight: 300;
  color: ${cream};
  margin: 0 0 14px;
  letter-spacing: -0.5px;
`;

const FullMenuSub = styled.p`
  font-family: ${sans};
  font-size: 0.93rem;
  font-weight: 300;
  font-style: italic;
  color: ${body};
  margin: 0;
`;

/*
  2-column centered grid for Breakfast + Dinner.
  justify-content: center keeps the pair in the middle
  regardless of viewport width.
*/
const FullMenuGrid = styled.div`
  display: flex;
  justify-content: center;
  gap: 28px;
  flex-wrap: wrap;
  max-width: 900px;
  margin: 0 auto;

  /* Each card takes exactly half the container minus the gap */
  & > * {
    flex: 0 0 calc(50% - 14px);
    max-width: 400px;
    min-width: 260px;
  }

  @media (max-width: 640px) {
    & > * {
      flex: 0 0 100%;
      max-width: 400px;
    }
  }
`;

const FullMenuCard = styled.div`
  position: relative;
  border-radius: 18px;
  overflow: hidden;
  cursor: pointer;
  border: 1px solid rgba(201,169,110,0.14);
  background: ${slate};
  transition: border-color 0.4s;
  &:hover { border-color: rgba(201,169,110,0.5); }
`;

const FMLabel = styled.div`
  position: absolute;
  top: 14px;
  left: 16px;
  z-index: 3;
  font-family: ${slab};
  font-size: 1.9rem;
  letter-spacing: 2px;
  color: ${gold};
  line-height: 1;
  text-shadow: 0 2px 14px rgba(0,0,0,0.8);
`;

const FMImgWrap = styled.div`
  position: relative;
  width: 100%;
  padding-top: 128%;
  overflow: hidden;
`;

const FMImg = styled.img`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.7s cubic-bezier(0.22, 1, 0.36, 1);
  ${FullMenuCard}:hover & { transform: scale(1.06); }
`;

const FMOverlay = styled.div`
  position: absolute;
  inset: 0;
  background: linear-gradient(180deg, transparent 40%, rgba(14,12,10,0.85) 100%);
  display: flex;
  align-items: flex-end;
  justify-content: center;
  padding-bottom: 24px;
  opacity: 0;
  transition: opacity 0.3s;
  ${FullMenuCard}:hover & { opacity: 1; }
`;

const FMZoom = styled.div`
  font-family: ${sans};
  font-size: 0.78rem;
  font-weight: 600;
  letter-spacing: 2px;
  text-transform: uppercase;
  color: ${cream};
  padding: 9px 22px;
  border: 1px solid rgba(245,240,232,0.45);
  border-radius: 100px;
  backdrop-filter: blur(6px);
`;

const FMBody = styled.div`
  padding: 18px 22px 22px;
`;

const FMSub = styled.div`
  font-family: ${sans};
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 3px;
  text-transform: uppercase;
  color: ${gold};
  margin-bottom: 5px;
`;

const FMTitle = styled.h3`
  font-family: ${display};
  font-size: 1.5rem;
  font-weight: 400;
  color: ${cream};
  margin: 0;
`;

/* ── Gallery ─────────────────────────────────────────────────── */
const GallerySection = styled.section`
  background: #0e0c0a;
  padding: 0 0 140px;
`;

const GalleryHeaderRow = styled.div`
  text-align: center;
  padding: 100px 40px 80px;
  @media (max-width: 768px) { padding: 70px 24px 56px; }
`;

const GalleryTitle = styled.h2`
  font-family: ${display};
  font-size: clamp(3rem, 5.5vw, 5.5rem);
  font-weight: 300;
  color: ${cream};
  margin: 0;
  letter-spacing: -0.5px;
`;

const StackedList = styled.div`
  max-width: 1100px;
  margin: 0 auto;
  padding: 0 40px;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 60px 40px;
  @media (max-width: 768px) { grid-template-columns: 1fr; padding: 0 24px; gap: 60px; }
`;

const StackedItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0;
`;

const StackedTextRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding-bottom: 20px;
`;

const StackedLeft = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 14px;
`;

const StackedNum = styled.div`
  font-family: ${slab};
  font-size: 4rem;
  line-height: 1;
  color: rgba(201,169,110,0.15);
  flex-shrink: 0;
  margin-top: -6px;
`;

const StackedSub = styled.div`
  font-family: ${sans};
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 4px;
  text-transform: uppercase;
  color: ${gold};
  margin-bottom: 10px;
`;

const StackedTitle = styled.h3`
  font-family: ${display};
  font-size: clamp(2rem, 3.5vw, 3rem);
  font-weight: 300;
  color: ${cream};
  margin: 0;
  line-height: 1.1;
  letter-spacing: -0.3px;
`;

const StackedRight = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-items: flex-start;
  padding-left: 0;
`;

const StackedDesc = styled.p`
  font-family: ${sans};
  font-size: 0.97rem;
  font-weight: 300;
  line-height: 1.9;
  color: rgba(245,240,232,0.6);
  margin: 0;
`;

const StackedTag = styled.div`
  display: inline-flex;
  font-family: ${sans};
  font-size: 9px;
  font-weight: 600;
  letter-spacing: 2.5px;
  text-transform: uppercase;
  color: ${gold};
  padding: 7px 18px;
  border: 1px solid rgba(201,169,110,0.3);
  border-radius: 100px;
`;

const StackedDivider = styled.div`
  width: 100%;
  height: 1px;
  background: linear-gradient(90deg, rgba(201,169,110,0.3), transparent);
  margin-bottom: 28px;
`;

const StackedImgWrap = styled.div`
  position: relative;
  width: 100%;
  cursor: zoom-in;
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid rgba(201,169,110,0.08);
  &:hover img { transform: scale(1.02); }
  &:hover > div { opacity: 1; }
`;

/* width 100% height auto = full image always visible, never cropped */
const StackedImg = styled.img`
  display: block;
  width: 100%;
  height: auto;
  transition: transform 0.7s cubic-bezier(0.22, 1, 0.36, 1);
`;

const StackedOverlay = styled.div`
  position: absolute;
  inset: 0;
  background: rgba(14,12,10,0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.3s;
`;

const StackedOverlayBtn = styled.div`
  font-family: ${sans};
  font-size: 0.82rem;
  font-weight: 600;
  letter-spacing: 2.5px;
  text-transform: uppercase;
  color: ${cream};
  padding: 14px 34px;
  border: 1px solid rgba(245,240,232,0.55);
  border-radius: 100px;
  backdrop-filter: blur(8px);
`;

/* ── Marquee ─────────────────────────────────────────────────── */
const MarqueeStrip = styled.div`
  background: ${gold};
  padding: 13px 0;
  overflow: hidden;
  white-space: nowrap;
`;

const MarqueeInner = styled.div`
  display: inline-flex;
  animation: ${marquee} 22s linear infinite;
`;

const MarqueeText = styled.span`
  font-family: ${slab};
  font-size: 1rem;
  letter-spacing: 4px;
  color: ${ink};
  padding: 0 32px;
`;

/* ── Lightbox ────────────────────────────────────────────────── */
const Lightbox = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(10, 8, 6, 0.97);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
  padding: 40px 20px;
  cursor: pointer;
  backdrop-filter: blur(12px);
  overflow-y: auto;
`;

const LBContent = styled.div`
  position: relative;
  max-width: 1060px;
  width: 100%;
  cursor: default;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const LBClose = styled.button`
  position: fixed;
  top: 26px;
  right: 32px;
  background: rgba(201,169,110,0.12);
  border: 1px solid ${gold};
  color: ${gold};
  width: 50px;
  height: 50px;
  border-radius: 50%;
  font-size: 17px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s;
  z-index: 10002;
  font-family: ${sans};
  &:hover { background: ${gold}; color: ${ink}; transform: rotate(90deg); }
  @media (max-width: 768px) { top: 14px; right: 14px; }
`;

const LBHint = styled.div`
  position: fixed;
  top: 38px;
  left: 38px;
  font-family: ${sans};
  font-size: 0.76rem;
  font-weight: 400;
  letter-spacing: 1.5px;
  color: rgba(245,240,232,0.35);
  z-index: 10002;
  @media (max-width: 768px) { display: none; }
`;

const LBImg = styled.img`
  width: 100%;
  max-height: 78vh;
  object-fit: contain;
  border-radius: 10px;
  box-shadow: 0 40px 100px rgba(0,0,0,0.9);
`;

const LBMeta = styled.div`
  text-align: center;
  margin-top: 26px;
  padding: 26px 32px;
  background: rgba(255,255,255,0.025);
  border: 1px solid rgba(201,169,110,0.14);
  border-radius: 14px;
  width: 100%;
  max-width: 680px;
`;

const LBSub = styled.div`
  font-family: ${sans};
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 3px;
  text-transform: uppercase;
  color: ${gold};
  margin-bottom: 8px;
`;

const LBTitle = styled.h3`
  font-family: ${display};
  font-size: 1.9rem;
  font-weight: 400;
  color: ${cream};
  margin: 0 0 10px;
`;

const LBDesc = styled.p`
  font-family: ${sans};
  font-size: 0.92rem;
  font-weight: 300;
  line-height: 1.8;
  color: ${body};
  margin: 0;
`;